import { createContext, useContext, useState, useRef, useCallback } from 'react';

const OfferFormContext = createContext(null);

export const useOfferFormContext = () => {
    const context = useContext(OfferFormContext);
    if (!context) {
        throw new Error('useOfferFormContext must be used within an OfferFormLayout');
    }
    return context;
};

export const OfferFormProvider = ({ children }) => {
    const [nextLabel, setNextLabel] = useState('Next');
    const [isNextDisabled, setIsNextDisabled] = useState(false);
    const [isNextLoading, setIsNextLoading] = useState(false);
    const triggerNextRef = useRef(null);

    const registerNextAction = useCallback((action) => {
        triggerNextRef.current = action;
    }, []);

    const triggerNext = useCallback(() => {
        if (triggerNextRef.current) {
            triggerNextRef.current();
        }
    }, []);

    return (
        <OfferFormContext.Provider value={{
            nextLabel,
            setNextLabel,
            isNextDisabled,
            setIsNextDisabled,
            isNextLoading,
            setIsNextLoading,
            registerNextAction,
            triggerNext
        }}>
            {children}
        </OfferFormContext.Provider>
    );
};
